import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const CustomAlert = ({
  open,
  message,
  severity,
  onClose
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        variant="filled"
        sx={{ 
          width: '100%',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          alignItems: 'center'
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomAlert;